import {PayloadAction} from "../payload-action.interface";
import {SettingEntity} from "./setting.entity";

export class SettingActions{
  static readonly ADD 		  = '[SettingActions] ADD';
  static readonly SET 		  = '[SettingActions] SET';

  static add(setting: SettingEntity): PayloadAction{
    return {
      type: SettingActions.ADD,
      payload: setting
    }
  }

  static set(setting: SettingEntity): PayloadAction{
    return {
      type: SettingActions.SET,
      payload: setting
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/setting/setting.actions.ts